import { defineStore } from "pinia";
import { ref } from "vue";
import { AdminType } from "@/api/admin/enum";

export const useTokenStore = defineStore(
  "token",
  () => {
    const accessToken = ref<string>("");
    const refreshToken = ref<string>("");

    const getRole = () =>  {
      try {
        const payloadBase64 = accessToken.value.split('.')[1];
        const payloadJson = atob(payloadBase64);
        const payload = JSON.parse(payloadJson);
        const role = payload.role;

        if (Object.values(AdminType).includes(role)) {
          return role as AdminType;
        }

        return null;
      } catch (e) {
        console.error('Invalid token:', e);
        return null;
      }
    }

    const checkViewer = () =>  {
      return getRole() !== AdminType.VIEWER
    }

    return {
      accessToken,
      refreshToken,
      getRole,
      checkViewer,
    };
  },
  {
    persist: true,
  }
);
